import React, { useState } from "react";
import Hero from "../components/Hero";
import NewArrivals from "../components/NewArrivals";
import ProductGrid from "../components/ProductGrid";
import "./Home.css";

const Home = () => {
  const [jumpTarget, setJumpTarget] = useState(null);

  const handleSelectNewArrival = (product) => {
    setJumpTarget({
      category: product.category,
      productId: product.id,
      ts: Date.now() // ensures effect re-fires even if same product clicked twice
    });
  };

  return (
    <div className="home-page">
      <Hero />
      <NewArrivals onSelectProduct={handleSelectNewArrival} />
      <ProductGrid jumpTarget={jumpTarget} />
    </div>
  );
};

export default Home;